import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const PrivateIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M8.8 8.3a1 1 0 0 1 1.4 0L12 10l1.8-1.8a1 1 0 1 1 1.4 1.4l-1.8 1.8 1.8 1.8a1 1 0 0 1-1.4 1.4L12 13l-1.8 1.8a1 1 0 0 1-1.4-1.4l1.8-1.8-1.8-1.8a1 1 0 0 1 0-1.4Z" />
      <path
        fillRule="evenodd"
        d="M11.6 1h.8l8 3c.3.2.6.6.6 1v7c0 3.4-2.3 6.2-4.3 8a22.7 22.7 0 0 1-4.2 2.9L12 22l-.4.9a8.3 8.3 0 0 1-.4-.2A21 21 0 0 1 7.3 20c-2-1.8-4.3-4.6-4.3-8V5c0-.4.3-.8.6-1l8-3Zm.4 20a19.9 19.9 0 0 0 3.3-2.4c2-1.7 3.7-4 3.7-6.5V5.7L12 3 5 5.7V12c0 2.6 1.7 4.8 3.7 6.5a20.7 20.7 0 0 0 3.3 2.4Z"
        clipRule="evenodd"
      />
      <path d="M11.6 22.9c.2.1.6.1.8 0L12 22l-.4.9Z" />
    </Icon>
  )
);
export default PrivateIcon;
